import { FC } from 'react'
import { InformationTooltip } from '@omnea-app/omui/InformationTooltip'

type Props = {
  label: string
  tooltip: string
}

export const ColumnHeaderWithTooltip: FC<Props> = ({ label, tooltip }) => (
  <>
    {label}
    <InformationTooltip text={tooltip} placement="top" size={16} />
  </>
)
